import { networkSetupConfigs } from '../shared/constants';
import type { AvailableSetup } from '../shared/types';

export const setupNetwork = async (configName: AvailableSetup) => {
    // @ts-ignore
    const provider = window.ethereum;
    if (provider) {
      const config = networkSetupConfigs[configName];

      if (!config) {
        return false;
      }

      try {
        // @ts-ignore
        await provider.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: config.chainId }],
        });

        return true;
      } catch (switchError: any) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          try {
            // @ts-ignore
            await provider.request({
              method: 'wallet_addEthereumChain',
              params: [config],
            });
          } catch (addError) {
            console.log(addError)
            return false;
          }
        }

        return false;
      }
    }

    return true;
}
